module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.8ed86e3d.jpg";